module.exports = __webpack_public_path__ + "img/gameplay-divider.fff34586.svg";